import PropTypes from "prop-types"
import Icon from "components/planning_center_icon"
import { StackView } from "@planningcenter/tapestry-react"

const CHECK_INS_PURPLE = "#876096"

const AttendanceReportName = ({ attendanceReport }) => {
  return attendanceReport.remote_id ? (
    <StackView axis="horizontal" alignment="center">
      <Icon
        className="mr-1 font-size-1"
        symbol="logomark#check-ins"
        style={{ color: CHECK_INS_PURPLE }}
      />
      {attendanceReport.name}
    </StackView>
  ) : (
    <>{attendanceReport.name}</>
  )
}

AttendanceReportName.propTypes = {
  attendanceReport: PropTypes.shape({
    name: PropTypes.string,
    remote_id: PropTypes.integer
  })
}

export default AttendanceReportName
